import { GET_MESSAGE_DATA } from "components/gql/gql_queries_markcode";
import { logGQLError } from "data/functions";
import { useQueryWithEffect } from "../hooks/use-query-with-effect";

export function GetMessageQuery() {
  const queryName = "GetMessage";
  const queryText = GET_MESSAGE_DATA;

  const [refetch, variables] = useQueryWithEffect(queryText, {
    fetchPolicy: "no-cache",
    onCalled: ({ data, error }) => {
      if (error) {
        logGQLError(error, queryName);
      }
    },
  });

  return [refetch, variables];
}
